module.exports = __webpack_public_path__ + "img/united-states-time-zone-map.4c160579.jpg";